module.exports = __webpack_public_path__ + "static/logo-a6b78871fe390d9f6164e3f84bd7c36d.png";